export const mediaQueryMobile = "767px";
export const mediaQueryTablet = "1024px";
export const mediaQueryTabletLarge = "1124px";
export const mediaQueryDesktop = "1200px";